import { BackButton } from "@vega-core/components/Buttons/BackButton/BackButton";
import { useTheme } from "@vega-core/context/ThemeContext/ThemeContext";
import { useDeviceWidth } from "@vega-core/hooks/useDeviceWidth";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isFalsy } from "@vega-core/utils/isFalsy";

type Props = {
  goBack?: VoidFunction;
  hideBanner?: boolean;
  isContainer?: boolean;
  noPadding?: boolean;
  riskPagePath?: string;
};

export function RiskWarningCard({
  goBack,
  hideBanner,
  isContainer,
  noPadding,
  riskPagePath,
}: Props) {
  const { theme } = useTheme();
  const isMobile = !useDeviceWidth("md");

  return (
    <div
      className={cnTwMerge("top-0 z-10 font-light", {
        hidden: hideBanner,
        sticky: !isMobile || isContainer,
      })}
    >
      <div
        aria-label={m.invest_investInfo()}
        className={cnTwMerge(
          "rounded pb-4 pt-2 text-xs text-text/primary  md:pt-4 md:text-sm backdrop-bg lg:px-0",
          theme,
          {
            "px-0": noPadding,
            "px-4": isFalsy(noPadding),
          },
        )}
      >
        {isFalsy(hideBanner) ? (
          <div
            className={cnTwMerge("flex justify-center", {
              "lg:px-0 w-[90%]": isFalsy(noPadding) && !goBack,
              "lg:px-4": isFalsy(noPadding) || goBack,
            })}
          >
            <p>
              {m.invest_investInfo()}{" "}
              <a
                className="text-brand-default"
                href={riskPagePath ?? "/legal/risk_warning"}
              >
                {m.invest_investInfoLink()}
              </a>
            </p>
          </div>
        ) : null}
        {goBack ? (
          <div className="mt-4 md:mt-5">
            <BackButton onClick={goBack} />
          </div>
        ) : null}
      </div>
    </div>
  );
}
